/* 准备动态添加的路由 */
import layout from "@/pages/default/default.vue"
import workTable from "@/pages/workTable/workTable.vue"
//人事
import talentsStore from "@/pages/personnel/talentsStore.vue"
import talentsDetail from "@/pages/personnel/talentsDetail.vue"
import staffRecord from "@/pages/personnel/staffRecord.vue"
import staffDetail from "@/pages/personnel/staffDetail.vue"
import dimissionRecord from "@/pages/personnel/dimissionRecord.vue"
import dimissionDetail from "@/pages/personnel/dimissionDetail.vue"
import checkManage from "@/pages/personnel/checkManage.vue"
import clockRules from "@/pages/personnel/clockRules.vue"
import shiftManage from "@/pages/personnel/shiftManage.vue"
import organizeManage from "@/pages/personnel/organizeManage.vue"
//个人
import checkRecord from "@/pages/self/checkRecord.vue"
import reimburseList from "@/pages/self/reimburseList.vue"
import leaveSituation from "@/pages/self/leaveSituation.vue"
//设置
import setMenus from "@/pages/set/setMenus.vue"
import setApps from "@/pages/set/setApps.vue"
import permissionManage from "@/pages/set/permissionManage.vue"
import advertManage from "@/pages/set/advertManage.vue"
import expressManage from "@/pages/set/expressManage.vue"
import addExpress from "@/pages/set/addExpress.vue"
import notAudit from "@/pages/set/notAudit.vue"
//报销
import reimburseManage from "@/pages/reimburse/reimburseManage"
import reimburseDetail from "@/pages/reimburse/reimburseDetail"
//通知管理
import noticeManage from '@/pages/notice/noticeManage'
import noticeSend from '@/pages/notice/noticeSend'
import noticeDetail from '@/pages/notice/noticeDetail'

/* 动态路由 */
let dynamicRouter = [{
    path: '',
    name: 'container',
    redirect: '',
    component: layout,
    children: [{
        path: '/workTable',
        name: 'workTable',
        component: workTable,
        meta: {
            title: ''
        }
    }, {
        path: '/talentsStore',
        name: 'talentsStore',
        component: talentsStore,
        meta: {
            title: ''
        },
    }, {
        path: '/staffRecord',
        name: 'staffRecord',
        component: staffRecord,
        meta: {
            title: ''
        }
    }, {
        path: '/dimissionRecord',
        name: 'dimissionRecord',
        component: dimissionRecord,
        meta: {
            title: ''
        }
    }, {
        path: '/checkManage',
        name: 'checkManage',
        component: checkManage,
        meta: {
            title: ''
        }
    }, {
        path: '/checkRecord',
        name: 'checkRecord',
        component: checkRecord,
        meta: {
            title: ''
        }
    }, {
        path: '/leaveSituation',
        name: 'leaveSituation',
        component: leaveSituation,
        meta: {
            title: ''
        }
    }, {
        path: '/organizeManage',
        name: 'organizeManage',
        component: organizeManage,
        meta: {
            title: ''
        }
    }, {
        path: '/permissionManage',
        name: 'permissionManage',
        component: permissionManage,
        meta: {
            title: ''
        }
    }, {
        path: '/shiftManage',
        name: 'shiftManage',
        component: shiftManage,
        meta: {
            title: ''
        }
    }, {
        path: '/setMenus',
        name: 'setMenus',
        component: setMenus,
        meta: {
            title: ''
        }
    }, {
        path: '/setApps',
        name: 'setApps',
        component: setApps,
        meta: {
            title: ''
        }
    }, {
        path: '/advertManage',
        name: 'advertManage',
        component: advertManage,
        meta: {
            title: ''
        }
    }, {
        path: '/expressManage',
        name: 'expressManage',
        component: expressManage,
        meta: {
            title: ''
        }
    }, {
        path: '/reimburseList',
        name: 'reimburseList',
        component: reimburseList,
        meta: {
            title: ''
        }
    }, {
        path: '/reimburseManage',
        name: 'reimburseManage',
        component: reimburseManage,
        meta: {
            title: ''
        }
    }, {
        path: '/noticeManage',
        name: "noticeManage",
        component: noticeManage,
        meta: {
            title: ''
        }
    }, {
        path: '/notAudit',
        name: "notAudit",
        component: notAudit,
        meta: {
            title: ''
        }
    }]
}]

/* 静态路由 */
let staticRouter = [{
        path: '/talentsDetail',
        name: 'talentsDetail',
        component: talentsDetail,
        meta: {
            title: '',
            isSecond: true
        }
    }, {
        path: '/clockRules',
        name: 'clockRules',
        component: clockRules,
        meta: {
            title: '',
            isSecond: true
        }
    }, {
        path: '/dimissionDetail',
        name: 'dimissionDetail',
        component: dimissionDetail,
        meta: {
            title: '',
            isSecond: true
        }
    }, {
        path: '/staffDetail',
        name: 'staffDetail',
        component: staffDetail,
        meta: {
            title: '',
            isSecond: true
        }
    }, {
        path: '/reimburseDetail',
        name: 'reimburseDetail',
        component: reimburseDetail,
        meta: {
            title: '',
            isSecond: true
        }
    }, {
        path: '/addExpress',
        name: 'addExpress',
        component: addExpress,
        meta: {
            title: ''
        }
    }, {
        path: '/noticeSend',
        name: 'noticeSend',
        component: noticeSend,
        meta: {
            title: '',
            isSecond: true
        }
    },
    {
        path: '/noticeDetail',
        name: 'noticeDetail',
        component: noticeDetail,
        meta: {
            title: '',
            isSecond: true
        }
    }
]

export default {
    dynamicRouter,
    staticRouter
}


// WEBPACK FOOTER //
// ./src/router/router.js